import React from 'react';

import { formatValue, displayNetworks } from '../common/utils';
import { getClass } from '../../../utils/component-helpers';
import Tooltip from '../../misc/tooltip';

const addTooltip = (el, networks, columnObj) => {
	if (el && columnObj.name === 'affiliate_networks' && networks && networks.length > 1) {
		new Tooltip(el, {text: displayNetworks(networks, 'tooltip'), size: 1});
	}
};

const TotalRow = ({ columns, data, statType, showTotals, location, shadows }) => {
	if (!showTotals) return null;

	if (statType === 'product') {
		data.merchant_name = data.merchant_name || 'Multiple';
	}

	const emptyColumns = [
		'attribution_model', 'commission_rate', 'commission_rate_new', 'oon_clicks',
		'pricing_model', 'product_price', 'publisher_effective_cpc', 'pub_name',
		'name', 'type', 'labels', 'strategy_type', 'datetime_start', 'datetime_end',
	];
	return !location.search.includes('search_query') ? (
		<div className="totals-row">
			{columns.map((columnObj, index) => {
				if (!columnObj.selected || columnObj.exclude) return null;
				const hasShadow = ['merch-ed-overview', 'merchant-performance-overview'].includes(statType);

				if (index === 0) {
					return (
						<div
							key={index}
							className={getClass(`column ${columnObj.name}`, {
								'no-shadow': hasShadow && !shadows.left,
							})}>
							<p className="total-label">Total</p>
						</div>
					);
				}

				if (columnObj.name === 'affiliate_networks') {
					return (
						<div
							key={index}
							className={getClass(`column ${columnObj.name}`, {
								'no-shadow': hasShadow && !shadows.left,
							})}
							ref={(node) => addTooltip(node, data.affiliate_networks, columnObj)}>
							<p className={displayNetworks(data.affiliate_networks, 'label')}>
								{displayNetworks(data.affiliate_networks, 'label')}
							</p>
						</div>
					);
				} else if (emptyColumns.includes(columnObj.name) && statType !== 'merchantRecommendation') {
					// TODO: remove with cr feature toggle
					const className = columnObj.name === 'commission_rate_new'
						? 'commission_rate'
						: columnObj.name;
					return (
						<div
							key={index}
							className={getClass(`column ${columnObj.name}`, {
								'no-shadow': hasShadow && !shadows.left,
							})}>
							<p>-</p>
						</div>
					);
				}

				return (
					<div
						key={index}
						className={getClass(`column ${columnObj.name}`, {
							'no-shadow': hasShadow && !shadows.left,
						})}
						ref={(node) => addTooltip(node, data.affiliate_networks, columnObj)}>
						<p className="value">
							{formatValue(
								data[columnObj.name], columnObj.type,
								columnObj.name, true
							)}
						</p>
					</div>
				);
			})}
		</div>
	) : null;
};

export default TotalRow;
